export default class InfoPanelButtonLayout {

    constructor(buttons) {
        this._buttons = buttons;

        //Assumptions:
        //- all buttons have same width
        //- all buttons have same scale in assets, and scaleX == scaleY
        //- all buttons have their regX in the center

        const n = this._buttons.length, first = this._buttons[0].target
        const b = first.getTransformedBounds();
        this._left = b.x;
        const width = b.width;
        this._spacing = SPACING;
        this._scaleLarge = first.scaleX * SCALE_SELECTED;
        this._widthLarge = width * this._scaleLarge;
        this._scaleSmall = first.scaleX * (1 - ((this._widthLarge - width) / (n - 1)) / width);
        this._widthSmall = width * this._scaleSmall;
        this._spacingNoSelection = this._spacing + (this._widthLarge - this._widthSmall) / (n - 1);
    }

    setSelected(index) {
        let x = this._left;
        const spacing = index > -1 ? this._spacing : this._spacingNoSelection;
        this._buttons.forEach((button, idx) => {
            const target = button.target;
            const scale = idx == index ? this._scaleLarge : this._scaleSmall;
            const width = idx == index ? this._widthLarge : this._widthSmall;
            const tx = x + width / 2;
            x += width + spacing;
            createjs.Tween.get(target).to({ scaleX: scale, scaleY: scale, x: tx }, 300, createjs.Ease.getBackOut(2.5));
        });
    }
}

const SPACING = 4;
const SCALE_SELECTED = 1.5;